import { render, staticRenderFns } from "./mzDiseaseBank.vue?vue&type=template&id=6838bd0d&scoped=true"
import script from "./mzDiseaseBank.vue?vue&type=script&lang=js"
export * from "./mzDiseaseBank.vue?vue&type=script&lang=js"
import style0 from "./mzDiseaseBank.vue?vue&type=style&index=0&id=6838bd0d&prod&scoped=true&lang=css"
import style1 from "./mzDiseaseBank.vue?vue&type=style&index=1&id=6838bd0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838bd0d",
  null
  
)

export default component.exports